import React from 'react';
import { useAppDispatch } from 'appRoot/Store';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import { BookingCreatorState } from 'booking-creator/rootReducer';
import { BookingMode } from 'booking-creator/reducers/display/types';
import EditBlockouts from 'external-components/blockout-by-service-editor/EditBlockouts';
import NewBlockout from 'external-components/blockout-by-service-editor/NewBlockout';
import { ToastActionClean } from 'app/actions/toast.actions';
import { NBIProject, ToastType } from 'shared-types/SharedTypes';
import { rootDisplayActions } from 'app/reducers/display/slice';

const NS = 'BlockoutsByService';

export default function BlockoutsByService({ handleModalClose }: { handleModalClose: () => void }) {
  const dispatch = useAppDispatch();
  const mode = useSelector((state: DiaryRootState) => state.rootDisplayReducer.mode);
  const refreshHiddenService = useSelector((state: DiaryRootState) => state.rootDisplayReducer.refreshHiddenService);

  const handleClose = ()=>{
    handleModalClose()
  }
  const handleSave = (msg: string) => {
    ToastActionClean.showToast(msg, ToastType.success)
    dispatch(rootDisplayActions.setRefreshHiddenService(!refreshHiddenService));
    setTimeout(() => {
      ToastActionClean.clearToast();
    }, 3000)
  }
  return (
    <div style={{height: '100%'}}>
      {mode === 'edit' ? <EditBlockouts exit={() => handleModalClose} /> : <NewBlockout createdBy={NBIProject.DIARY} exit={() => handleClose()} saveCallback={handleSave} />}
    </div>
  );
}
